module.exports = __webpack_public_path__ + "img/logo.3ea1611d.png";